export const environment = {
  production: false,
  apiUrl: 'https://wsqa.frakcio.com/api/v1/admin',
  MIDDLEWARE_IP: 'http://localhost:7036',
  MIDDLEWARE_USER: 'frakciolistener',
  MIDDLEWARE_PASSWORD: 'BUzyIkeQ3MtQBb1KQ0MVgR0bqaKO6EAU9BZK8HX0',
};
